import { render } from "./DataChain.vue?vue&type=template&id=618f172a&scoped=true"
import script from "./DataChain.vue?vue&type=script&lang=js"
export * from "./DataChain.vue?vue&type=script&lang=js"

import "./DataChain.vue?vue&type=style&index=0&id=618f172a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618f172a"]])

export default __exports__